__turbopack_context__.v({
  "className": "space_mono_d7641128-module__EGc1KW__className",
});
